/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { GGCCTarget } from '@app/core/types';

export const getProjectName = (target: GGCCTarget) => `GridGain ${getProjectNameShort(target)}`;
export const getProjectNameShort = (target: GGCCTarget) => (target === 'hosted' ? 'Nebula' : 'Control Center');
